const setting = {
  systemName: {
    "srm.snms.eekafashion.com.cn:9002": {
      loginIcon: false,
      loginName: "服装供应链管理平台",
      indexIcon: false,
      indexName: "供应链管理平台",
      filingMes: false,
      title: "服装供应链管理平台",
      loginBackgroundImg: "bg2"
    },
    "10.7.121.122:9002": {
      loginIcon: false,
      loginName: "服装供应链管理平台",
      indexIcon: false,
      indexName: "供应链管理平台",
      filingMes: false,
      title: "服装供应链管理平台",
      loginBackgroundImg: "bg2"
    },
    "202.170.130.245:9002": {
      loginIcon: false,
      loginName: "服装供应链管理平台",
      indexIcon: false,
      indexName: "供应链管理平台",
      filingMes: false,
      title: "服装供应链管理平台",
      loginBackgroundImg: "bg2"
    },
    "srm.snms.eekafashion.com.cn:9001": {
      loginIcon: false,
      loginName: "服装行业供应商管理平台",
      indexIcon: false,
      indexName: "供应商管理平台",
      filingMes: false,
      title: "服装行业供应商管理平台",
      loginBackgroundImg: "bg"
    },
    "10.7.121.122:9001": {
      loginIcon: false,
      loginName: "服装行业供应商管理平台",
      indexIcon: false,
      indexName: "供应商管理平台",
      filingMes: false,
      title: "服装行业供应商管理平台",
      loginBackgroundImg: "bg"
    },
    "202.170.130.245:9001": {
      loginIcon: false,
      loginName: "服装行业供应商管理平台",
      indexIcon: false,
      indexName: "供应商管理平台",
      filingMes: false,
      title: "服装行业供应商管理平台",
      loginBackgroundImg: "bg"
    },
    default: {
      loginIcon: true,
      loginName: "赢家供应商协同平台",
      indexIcon: true,
      indexName: "供应商平台",
      filingMes: true,
      title: "赢家供应商协同平台",
      loginBackgroundImg: "bg"
    }
  }
};

export default setting;

export const getSystemName = (host = window.location.host) => {
  return setting.systemName[host]
    ? setting.systemName[host]
    : setting.systemName.default;
};



// WEBPACK FOOTER //
// ./src/assets/js/setting.js